export default {
  title: 'Dettagli prezzo',
  subtotal: 'Subtotale',
  method_fee: 'Costo di consegna',
  tip: 'Mancia',
  service_fee: 'Elaborazione online',
  payment_method_upcharge_fee: 'Commissione PayPal',
  discount: 'Sconto',
  taxes: 'Tasse',
  total: 'Totale',
};
